import React from 'react';
import { Col, Drawer, Row, Checkbox, Button, Form, Input } from 'antd';
import {
  DrawerFooter,
  DrawerTitle,
  FileContainer,
  ResolutionContainer,
  ResolutionText,
  ResolutionTextBottom,
  ResolutionTitle,
  TitleFileContent,
} from './DocumentViewer.styles';
import Resolution from './resolution/Resolution';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

interface Props {
  visible: boolean;
  onClose: () => void;
}

const FileTypeOptions = [
  'Health Certificate',
  'Veterinary Health Report',
  'Vaccination record',
];

export default function DocumentViewer(props: Props): React.ReactElement {
  const { visible, onClose } = props;

  const renderTitle = () => {
    return (
      <div>
        <DrawerTitle>Document review</DrawerTitle>
        <TitleFileContent>
          <span>filenameVHR0001.pdf contains:</span>
          <CheckboxGroup options={FileTypeOptions} />
          <Button>Apply changes</Button>
        </TitleFileContent>
      </div>
    );
  };

  return (
    <Drawer
      width={'64%'}
      title={renderTitle()}
      placement="right"
      closable={true}
      onClose={onClose}
      visible={visible}
      key="right"
      className="drawer-file"
    >
      <Row>
        <Col span={17}>
          <FileContainer>
            <embed
              src="http://www.orimi.com/pdf-test.pdf"
              width="100%"
              height="100%"
            ></embed>
          </FileContainer>
        </Col>
        <Col span={7}>
          <ResolutionTitle>
            <DrawerTitle>Approve / Reject</DrawerTitle>
          </ResolutionTitle>
          <ResolutionContainer>
            <ResolutionText>
              <span>
                Please select the resolution for each document type in this submission.
              </span>
            </ResolutionText>
            <Resolution title="Health Cerificate"></Resolution>
            <Resolution title="Veterinary Health Report"></Resolution>
            <Resolution title="Vaccination Record"></Resolution>

            <Form className="form-textarea">
              <Form.Item label=" Add note (optional)">
                <TextArea rows={4} placeholder="Type Here"></TextArea>
              </Form.Item>
            </Form>
            <ResolutionTextBottom>
              <span>
                By clicking the <strong>Confirm</strong> button, you accept the document
                type and its contents in this submission.
              </span>
            </ResolutionTextBottom>
          </ResolutionContainer>
        </Col>
      </Row>
      <Row>
        <DrawerFooter>
          <Button type="ghost">Cancel</Button>
          <Button type="primary">Confirm</Button>
        </DrawerFooter>
      </Row>
    </Drawer>
  );
}
